import Image from 'next/image';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import Button from '@/components/Button';
import scans from './scans.png';
import { noop } from '@/lib/constants';
import Link from 'next/link';

const BgBlur1 = () => {
  return (
    <div className="absolute -right-[24rem] -top-[10rem] z-10 size-[40rem] bg-gradient-radial from-[#30C9BE] to-transparent to-70% opacity-30"></div>
  );
};

const BgBlur2 = () => {
  return (
    <div className="absolute -top-[15rem] left-[5rem] z-10 size-[40rem] bg-gradient-radial from-[#1E50FF] to-transparent to-70% opacity-30"></div>
  );
};

export function BuildScanBanner() {
  return (
    <Link
      href={'/scans'}
      scroll={false}
      className="mega-menu-link group relative w-full overflow-hidden rounded-lg border border-dark-background bg-[#20293A] p-6 transition-all duration-300 hover:border hover:border-white"
    >
      <BgBlur1 />
      <BgBlur2 />
      <Image src={scans} alt="Image of build scan page" className="absolute bottom-0 right-[10rem] z-10 w-[33%]" />
      <div className="flex max-w-[50%] flex-col gap-2">
        <h6 className="text-body-bold  z-10">
          Run a <span className="gradle-gradient-text">FREE</span> Build Scan
        </h6>
        <p className="text-label z-10 text-gray-4">
          Build Scan® is a free feature of Develocity® that provides deep analytic information for each of your local
          and CI builds.
        </p>
      </div>
      <Button
        outline
        variant="ghost-light"
        size="xs"
        className="absolute bottom-3 right-7 self-end duration-300 group-hover:-translate-y-0.5 group-hover:bg-white group-hover:bg-gradient-to-br group-hover:outline-none"
        roundedFull
        onClick={noop}
      >
        <ArrowRightIcon className="size-6 group-hover:text-black" />
      </Button>
    </Link>
  );
}
